import React, { useEffect } from 'react';
import './Alert.style.scss';

// @ts-ignore
const Alert = ({ message, type, duration = 5000, onClose }) => {
    useEffect(() => {
        // Configura un temporizador para cerrar automáticamente la alerta después del tiempo especificado
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        // Limpia el temporizador si el componente se desmonta
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`alert ${type}`} >
            <span>{message}</span>
            <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
    );
};

export default Alert;
